export default {
    alerts: [],
    errorMessage: 'Please try again later or email us at success@intempt.com',
}
